import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { EditComponent } from '../../../../components/edit-components/edit-component'
import { RichTextEditorComponent } from '../../../misc/components/rich-text-editor/rich-text-editor.component'

@Component({
  selector: 'jml-lib-multiline-editor',
  templateUrl: './multiline-editor.component.html',
  styleUrls: ['./multiline-editor.component.scss']
})
export class MultilineEditorComponent extends EditComponent {
  @Input() height = 10
  @Input() field: string

  @ViewChild('editor') editorComponent: RichTextEditorComponent

  private contentCache = ''

  constructor() {
    super()
  }

  handleBlur() {
    if (this.control?.value !== this.contentCache) {
      this.emitUpdate()
    }
  }

  handleFocus() {
    this.contentCache = this.control?.value || ''
    this.emitFocus()
  }
}
